import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import CheckIcon from 'mdi-react/ClipboardCheckOutlineIcon';
import TruckIcon from 'mdi-react/TruckIcon';

import BookStatus from 'modules/shared/BookingTable/components/BookStatus';
import BookingTable from 'modules/shared/BookingTable';
import TopBorderBtn from 'modules/shared/TopBorderBtn';
import BookingHelper from 'modules/shared/BookingTable/utils';
import { useModal } from 'modules/shared/hooks';
import { reservationsSelector } from 'modules/manager/containers/Booking/services/selectors';
import {
  getAllBooksError,
  getAllBooksRequest,
  getCellSettingsRequest,
  getLockedCellRequest,
  putBookRequest,
} from 'modules/manager/containers/Booking/services/actions';
import { logoutSelector } from 'modules/common/LogoutBtn/selectors';
import Loader from 'modules/kiosk/components/Loader';
import ErrorMsg from 'modules/shared/ErrorMsg';
import { PutReservation, Reservations } from 'entities/Reservations';
import moment from 'moment';
import BlockIcon from 'mdi-react/BlockIcon';
import directorBookingSchema from './schema';
import { getAllBranchRequest } from '../../../common/LogoutBtn/actions';
import { RootState } from '../../../../rootReducer';

const Booking: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCellSettingsRequest());
  }, []);
  const { isShow, openModal, closeModal } = useModal();
  const [update, setUpdate] = useState<boolean>();
  const [startDay, setStartDay] = useState<Date>();
  const [times, setTimes] = useState<string[]>([]);
  const { loading, error, books, unconfirmedBook, lockedCell } = useSelector(reservationsSelector);
  const cellSetting = useSelector((state: RootState) => state.managerModuleReducer.reservationsReducer.cellSetting);
  const { branchTitle } = useSelector(logoutSelector);
  const branchFromStorage = JSON.parse(localStorage.getItem('branchId') || 'null');

  useEffect(() => {
    dispatch(getAllBranchRequest());
  }, []);

  setTimeout(() => setUpdate(!update), 40000);

  const branchId = branchTitle?.id;

  const handlePrevWeek = () => {
    if (startDay) {
      const d = startDay.setDate(startDay.getDate() - 7);

      setStartDay(new Date(d));
      return true;
    }
  };

  const handleNextWeek = () => {
    if (startDay) {
      const d = startDay.setDate(startDay.getDate() + 7);
      setStartDay(new Date(d));
    }
  };

  const getDatas = (fromDate: Date) => {
    if (branchId) {
      // @ts-ignore
      const a = moment(fromDate).unix();
      const b = a + 6 * 86400;
      const c = new Date(moment.unix(b).format());

      const params = {
        branchId: `${branchId}`,
        from: fromDate,
        to: c,
      };
      dispatch(getLockedCellRequest(params));
      dispatch(getAllBooksRequest(params));
    } else {
      const date = fromDate.getDate() + 6;
      const toDate = new Date().setDate(date);

      const params = {
        branchId: `${branchFromStorage?.id}`,
        from: fromDate,
        to: new Date(toDate),
      };
      dispatch(getLockedCellRequest(params));
      dispatch(getAllBooksRequest(params));
    }
  };

  const handleOnBook = (value: Reservations) => {
    const params: PutReservation = {
      reservationId: value?.id,
      bookingStatus: value.bookingStatus,
      comment: value.comment,
    };
    dispatch(putBookRequest(params));
  };

  useEffect(() => {
    if (Object.keys(cellSetting).length !== 0) {
      if (!startDay) setStartDay(new Date());

      if (startDay) getDatas(startDay);
    }
  }, [startDay, cellSetting, update]);

  useEffect(() => {
    if (Object.keys(cellSetting).length !== 0) {
      if (cellSetting) {
        const time = BookingHelper.generateTimes(cellSetting);
        setTimes(time);
      } else {
        const time = BookingHelper.generateTimes(cellSetting);
        setTimes(time);
      }
    }
  }, [books, cellSetting]);

  useEffect(() => {
    if (error) {
      return openModal();
    }
    closeModal();
  }, [error]);

  return (
    <Container fluid className="mt-15">
      <Row className="w-100">
        <Col className="d-flex align-items-center col-10 pr-0">
          <span className="col-2">Умовні позначення:</span>
          <div className="d-flex flex-row align-items-center col-3">
            <CheckIcon className="text-success mr-1" size={18} />
            <span>Замовлення скомплектовано</span>
          </div>
          <div className="d-flex flex-row align-items-center col-3">
            <CheckIcon className="text-danger mr-1" size={18} />
            <span>Комплектація не готова</span>
          </div>
          <div className="d-flex flex-row align-items-center col-3">
            <TruckIcon className="mr-1" size={18} />
            <span>Машина в електронній черзі</span>
          </div>
          <div className="d-flex flex-row align-items-center col-3">
            <BlockIcon className="mr-1" size={18} />
            <span>Слот заповнено</span>
          </div>
        </Col>
      </Row>
      <Row className="w-100">
        <Col className="d-flex align-items-center col-10 pr-0">
          <span className="col-2">Статуси бронювання:</span>
          <div className="d-flex flex-row align-items-center col-3">
            <BookStatus status={1} />
            <span>Не підтверджена {unconfirmedBook ? `(${unconfirmedBook})` : ''}</span>
          </div>
          <div className="d-flex flex-row align-items-center col-3">
            <BookStatus status={2} />
            <span>Підтверджена</span>
          </div>
          <div className="d-flex flex-row align-items-center col-3">
            <BookStatus status={4} />
            <span>Відхилена</span>
          </div>
          <div className="d-flex flex-row align-items-center col-3">
            <BookStatus status={6} />
            <span>Завершено</span>
          </div>
        </Col>
        <div className="d-flex align-items-center justify-content-end col-2 p-0">
          <TopBorderBtn icon="calendarRefresh" className="border-0" clickHandler={() => setStartDay(new Date())} />
          <TopBorderBtn icon="left" clickHandler={handlePrevWeek} />
          <TopBorderBtn icon="right" clickHandler={handleNextWeek} className="ml-0 mr-4" />
        </div>
      </Row>
      {loading ? <Loader /> : null}
      {startDay && books && lockedCell && cellSetting ? (
        <BookingTable
          viewStartDate={startDay}
          times={times}
          duration={cellSetting?.slotDurationInMinutes || 30}
          schema={directorBookingSchema}
          onBook={handleOnBook}
          cellLocked={lockedCell}
          mode="ordering"
          maxReservationCount={cellSetting?.maxReservationCount}
        />
      ) : null}
      <ErrorMsg
        isShow={isShow}
        // @ts-ignore
        error={error?.message || 'Помилка при отриманні данних'}
        closeHandler={() => dispatch(getAllBooksError(null))}
      />
    </Container>
  );
};

export default Booking;
